export default __webpack_public_path__ + "static/media/artist1.4c64b37c.png";